export default __webpack_public_path__ + "static/media/bbshark-cock-doo-CJAD.c51e136f.jpg";